import { similarOffersReceived } from './similarOffersReceived';
import { getItemBasedSimilarOffers } from '../../../api/similar';

import type { IThunkActionCreator } from '../../index';
import type { ISimilarOffersReceivedData } from '../types';

export function requestItemBasedSimilarOffers(
  offerId: number,
  publishedUserId?: number,
): IThunkActionCreator<Promise<void>> {
  return (dispatch, getState, context) => {
    // обработки ошибок нет, и это нормально — деградируем без показа блока
    return getItemBasedSimilarOffers(context, { cianOfferId: offerId, publishedUserId }).then(res => {
      if (res.statusCode === 200) {
        dispatch(similarOffersReceived(res.response as ISimilarOffersReceivedData, 'itemBased'));
      }
    });
  };
}
